import React, { useState } from 'react';
import {
  Card,
  Divider,
  Button,
  Typography,
  CardContent,
} from '@material-ui/core/';
import { 
  GoogleMap,
  withScriptjs, 
  withGoogleMap, 
  Marker, 
  InfoWindow 
} from 'react-google-maps';
import MapStyles from './MapStyles';

function Map() {
  const [selected, setSelected] = useState(false);

  return (
    <GoogleMap 
      defaultZoom={11} 
      defaultCenter={{ lat: 48.88779, lng: 16.648551 }} 
      defaultOptions={{ styles: MapStyles }}
    >
    <Marker 
      key='chataDolniVestonice' 
      position={{ lat: 48.88773, lng: 16.648570 }} 
      onClick={()=> setSelected(true)}
      icon={{
        url: '/home.png',
        scaledSize: new window.google.maps.Size(40, 40)
      }}
    />

    {selected && (
      <InfoWindow 
        position={{ lat: 48.88779, lng: 16.648551 }} 
        onCloseClick={()=> setSelected(false)}
      >
        <Card>
          <CardContent>
            <Typography color='primary' variant='h6' >Dolní Věstonice 29</Typography>
            <Typography color='textSecondary' variant='subtitle1' >691 29 Dolní Věstonice</Typography>
            <Divider />
            <Button target='_blank' color='primary' variant='outlined'
              href='https://www.google.com/maps/dir//Doln%C3%AD+V%C4%9Bstonice+29,+691+29+Doln%C3%AD+V%C4%9Bstonice/@48.8877516,16.6462091,15.78z/data=!4m8!4m7!1m0!1m5!1m1!1s0x4712cc27124dc60f:0xdd3dc0a1fea6f2b5!2m2!1d16.6485538!2d48.8878026'
            >
              Naplánujte si cestu
            </Button>
          </CardContent>
        </Card>
      </InfoWindow>
    )}


    </GoogleMap>
  )
}

const WrappedMap =  withScriptjs(withGoogleMap(Map));
const API = 'AIzaSyD76cogR7k_JsjktewSNzQJ8mXfm2HJ5jo';

function GoogleMaps({fullWidth}){
  return (
    <div style={{ width: fullWidth && '100vw' }}>
      <WrappedMap 
          googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${API}`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `400px` }} />}
          mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  )
}

export default GoogleMaps;